import React, { Component } from "react";
import "./GoogleReviews.css";



const ImgUrl = "https://embedsocial.com/cdn/images/embedsocial-icon.png";


class GoogleReviews extends Component  {
    componentDidMount() {
        (function(d, s, id) { var js; if (d.getElementById(id)) {return;} js = d.createElement(s); js.id = id; js.src = "https://embedsocial.com/cdn/ht.js"; d.getElementsByTagName("head")[0].appendChild(js); }(document, "script", "EmbedSocialHashtagScript")); 
    }
    render() {

    return (
        <section className="reviews-section">
            <div className="section-header">
                <h2 className="section-title">AVALIAÇÕES NO <span className="highlight">GOOGLE</span></h2>
                <div className="divider"></div>
            </div>
            <div className="review-container">
                <div className="review">
                    <div className="embedsocial-hashtag" data-ref="38e9e21040e4bb22c07e0d1d2b2ec59a89cbbf38" data-lazyload="yes" >
                        <a className="feed-powered-by-es feed-powered-by-es-slider-img" href="https://embedsocial.com/blog/embed-google-reviews/" target="_blank" rel="noreferrer" title="Embed Google reviews">
                            <img src={ImgUrl} alt="EmbedSocial" /> Embed Google reviews </a> </div>
                </div>
            </div>
        </section>
    )

  
}

}
export default GoogleReviews;

